import { render, staticRenderFns } from "./COA-L.vue?vue&type=template&id=7bb8ff7e&scoped=true&"
import script from "./COA-L.vue?vue&type=script&lang=js&"
export * from "./COA-L.vue?vue&type=script&lang=js&"
import style0 from "./COA-L.vue?vue&type=style&index=0&id=7bb8ff7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8ff7e",
  null
  
)

export default component.exports